import axios, { InternalAxiosRequestConfig } from './axios';
import { Token } from 'models';

const errorHandler = (err: any) => {
  const res = {
    ...err,
    error_type: 'NETWORK_ERROR',
  };
  if (err.response) {
    res.error_type = 'SERVER_ERROR';
    res.status = err.response.status;
    if (err.response?.data?.error) {
      res.error_type = err.response?.data?.error;
    }
  } else if (err.request) {
    res.error_type = 'NO_RESPONSE';
    res.status = err.request.status;
  } else if (err.message === 'CANCELED') {
    res.error_type = 'CANCELED';
  }
  throw res;
};

const valetChecker = (request: InternalAxiosRequestConfig) => {
  const url: string | undefined = request.url;
  if (!url) return request;
  const pathArray = url.split('/');
  if (pathArray.includes('auth-service')) {
    request.headers.auth_key = import.meta.env.VITE_APP_CONNECT_V3_AUTH_KEY;
    return request;
  }
  if (['valet', 'opensearch', 'v3', 'ingestor-cropwise'].includes(pathArray[3])) {
    const cropwise_token: Token | null = JSON.parse(
      window.localStorage.getItem('cropwise_auth_token') ?? '',
    );
    const access_token = cropwise_token ? cropwise_token['access_token'] : '';
    if (!request.headers) return request;
    request.headers.Authorization = `Bearer ${access_token}`;
    return request;
  }
  return request;
};

axios.interceptors.request.use(valetChecker, errorHandler);
axios.interceptors.response.use(undefined, errorHandler);

export default axios;
